import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_formando-lideres/artifacts/dlfyfwxw_logo%20rise%20-%20Edited.png';

const NAV_ITEMS = [
  { name: 'Inicio', path: '/' },
  { name: 'Sobre Nosotros', path: '/sobre-nosotros' },
  { name: 'Información de Admisión', path: '/informacion-admision' },
  { name: 'Ofrecimientos', path: '/ofrecimientos' },
  { name: 'Galería', path: '/galeria' },
  { name: 'Artículos', path: '/articulos' },
  { name: 'Contacto', path: '/contacto' }
];

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  return (
    <nav className="glass-nav fixed w-full top-0 z-50" data-testid="main-navbar">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <div className="flex justify-between items-center h-24">
          <Link to="/" className="flex items-center flex-shrink-0" data-testid="logo-link">
            <img
              src={LOGO_URL}
              alt="Rise & Shine Learning Zone"
              className="h-16 md:h-20 w-auto"
              style={{ imageRendering: 'auto' }}
            />
          </Link>

          <div className="hidden md:flex items-center gap-7">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                data-testid={`nav-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
                className={`text-sm font-medium transition-colors ${
                  isActive(item.path) ? 'text-[#43b6b8]' : 'text-stone-700 hover:text-[#43b6b8]'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="/informacion-admision"
              data-testid="cta-solicita-info-nav"
              className="bg-[#d3b163] hover:bg-[#b89548] text-white px-6 py-2.5 rounded-full font-medium transition-all active:scale-95 shadow-md"
            >
              Solicita Información
            </Link>
          </div>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2"
            data-testid="mobile-menu-button"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {isOpen && (
          <div className="md:hidden py-4 space-y-3 bg-white border-t border-stone-100" data-testid="mobile-menu">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsOpen(false)}
                className={`block py-2 px-4 text-base font-medium ${
                  isActive(item.path) ? 'text-[#43b6b8]' : 'text-stone-700'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <div className="px-4 pt-2">
              <Link
                to="/informacion-admision"
                onClick={() => setIsOpen(false)}
                className="block w-full bg-[#d3b163] text-white px-6 py-2.5 rounded-full font-medium text-center"
              >
                Solicita Información
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};
